export default function getGroupKeyFromActivity(activity) {
    if (activity.rootPostId) return `${activity.rootPostId}|${activity.notificationType}|${activity.actorId || 0}`;
    return null;
};
